/**
 * 上传接口 URL 工具
 * el-upload 的 action 不经过 axios baseURL，必须手动拼 /website 前缀
 */
const BASE_PATH = (process.env.VUE_APP_API_BASE_URL || '/').replace(/\/+$/, '')

/**
 * 生成上传接口地址
 * @param {string} module - 上传模块 product/solution/wiki/navbar/common
 * @returns {string} 如 /website/api/upload?module=product
 */
export function getUploadUrl(module = '') {
  return `${BASE_PATH}/api/upload${module ? `?module=${module}` : ''}`
}

export default {
  getUploadUrl
}